/** Confirmación para acciones destructivas o irreversibles (suspender, eliminar, cancelar). */
import { useState, type ReactElement } from "react";

import { Modal } from "./Modal";

export function ConfirmDialog({
  title,
  message,
  confirmLabel = "Confirmar",
  danger = false,
  onConfirm,
  onCancel,
}: {
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
}): ReactElement {
  const [busy, setBusy] = useState(false);

  async function handleConfirm(): Promise<void> {
    setBusy(true);
    try {
      await onConfirm();
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal title={title} onClose={onCancel}>
      <p>{message}</p>
      <div className="form-actions">
        <button type="button" className="button-secondary" onClick={onCancel} disabled={busy}>
          Cancelar
        </button>
        <button type="button" className={danger ? "button-danger" : "button-primary"} onClick={() => void handleConfirm()} disabled={busy}>
          {busy ? "Procesando…" : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
